// ============================================================
// FILE: JobFeedRow.js
// LOCATION: C:\gardenmarket\web\src\pages\gardener\JobFeedRow.js
// ============================================================
// PURPOSE:
//   One row in the gardener's job feed list (left pane of the
//   master-detail layout on GardenerDashboard.js).
//   Shows date, title, suburb, matched badge, and quote status.
// ============================================================

import { colors } from '../../theme/theme';

export default function JobFeedRow({ job, isSelected, onClick }) {
    return (
        <tr onClick={onClick} style={{
            cursor:'pointer',
            backgroundColor: isSelected ? '#E8F5EE' : 'transparent',
            borderLeft: isSelected ? '3px solid #2d6a4f' : '3px solid transparent',
            borderBottom: `1px solid ${colors.border}`,
        }}>
            <td style={{ width:'60px', padding:'12px 8px 12px 14px', verticalAlign:'top', fontSize:'0.78rem', color:colors.textFaint, whiteSpace:'nowrap' }}>
                {job.preferred_date
                    ? new Date(job.preferred_date).toLocaleDateString('en-AU', { day:'numeric', month:'short' })
                    : '—'}
            </td>
            <td style={{ padding:'12px 8px', verticalAlign:'top', overflow:'hidden', maxWidth:'0', width:'100%' }}>
                <div style={{ fontSize:'0.93rem', fontWeight:700, color:colors.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {job.title}
                </div>
                <div style={{ fontSize:'0.8rem', color:colors.textFaint, marginTop:'2px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {job.suburb_name} {job.postcode}
                </div>
            </td>
            <td style={{ width:'80px', padding:'12px 14px 12px 8px', verticalAlign:'top', textAlign:'right' }}>
                {job.has_quoted ? (
                    <span style={{...badge, backgroundColor:'#DCFCE7', color:'#14532D'}}>✓ Quoted</span>
                ) : job.is_matched ? (
                    <span style={{...badge, backgroundColor:'#F3E8FF', color:'#6B21A8'}}>🎯 Match</span>
                ) : (
                    <span style={{...badge, backgroundColor:'#F5F5F5', color:colors.textFaint}}>In area</span>
                )}
            </td>
        </tr>
    );
}

const badge = {
    fontSize:'0.7rem', fontWeight:700,
    padding:'3px 8px', borderRadius:'999px',
    whiteSpace:'nowrap', display:'inline-block',
};
